import {Scene} from 'scene';

const IMG_COUNT = 5;
const FADE_TIME = 600;

const Sprite = PIXI.Sprite;
const TextureCache = PIXI.utils.TextureCache;

export default class sea_background extends Scene {

    constructor() {
        super();

        this.fons = [];
        for (let i = 0; i < IMG_COUNT; ++i) {
            let img = new Sprite(TextureCache['res/sea_backgrounds/sea_background_%d.jpg'.$(i)]);
            this.addChild(img);
            this.fons.push(img);
        }

        this.flowTweens = [];
    };

    terminate() {
        this.fons = null;

        this.flowTweens.forEach(tw => tw.stop());
        this.flowTweens = null;
    };

    startAnimate() {

        this.flowTweens.forEach(tw => tw.stop());
        this.flowTweens = [];

        this.fons[0].alpha = 1.0;

        for (let i = 1; i < this.fons.length; ++i){

            let fon = this.fons[i];
            fon.alpha = 0.0;

            let tw = new TWEEN.Tween(fon)
                .to({alpha: 1.0}, FADE_TIME)
                //.easing(TWEEN.Easing.Cubic.In);

            if (this.flowTweens.length > 0) {
                this.flowTweens[this.flowTweens.length - 1].chain(tw);
            }
            this.flowTweens.push(tw);
        }

        for (let i = this.fons.length - 1; i > 0; --i){

            let tw = new TWEEN.Tween(this.fons[i])
                .to({alpha: 0.0}, FADE_TIME)
                //.easing(TWEEN.Easing.Cubic.Out);

            if (this.flowTweens.length > 0) {
                this.flowTweens[this.flowTweens.length - 1].chain(tw);
            }
            this.flowTweens.push(tw);
        }

        this.flowTweens[this.flowTweens.length - 1].chain(this.flowTweens[0]);
        this.flowTweens[0].start();

    };

    stopAnimate() {
        this.flowTweens.forEach(tw => tw.stop());
        this.flowTweens = [];
    };

}


// WEBPACK FOOTER //
// ./src/sea_background.es6